export default "__VITE_ASSET__Df0N38Tk__"